import { render, staticRenderFns } from "./BannersManager.html?vue&type=template&id=07d07135&scoped=true&external"
import script from "./BannersManager.js?vue&type=script&lang=js&external"
export * from "./BannersManager.js?vue&type=script&lang=js&external"
import style0 from "./BannersManager.scss?vue&type=style&index=0&id=07d07135&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d07135",
  null
  
)

export default component.exports